import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { EXTERNAL_API } from '../externalApisClient';
import { TFinalSpeechToTextResponse } from '../types';

/**
 * This will track the status of this long running google speech recognition query.
 */
const GOOGLE_SPEECH_TO_TEXT_RECOGNITION_MUTATION_KEY =
  'google-speech-to-text-recognition-query-key';

interface IGoogleSpeechToTextRecognitionOptions {
  onErrorCallback: (err: IApiError) => void;
  onSuccessCallback: (responseData: TFinalSpeechToTextResponse) => void;
}

/**
 * This hook starts a long running Google Speech to Text API task that will process
 * an array of words audio, encoded as a base64 string, and return the recognized
 * words back on success.
 */
export const useGoogleSpeechToTextRecognitionMutation = ({
  onErrorCallback,
  onSuccessCallback,
}: IGoogleSpeechToTextRecognitionOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [GOOGLE_SPEECH_TO_TEXT_RECOGNITION_MUTATION_KEY],
    networkMode: 'always',
    retry: false,
    mutationFn: EXTERNAL_API.processSpeechToTextWithGoogle,
    onSuccess: onSuccessCallback,
    onError: onErrorCallback,
  });

  return {
    error,
    isPending,
    processSpeechToTextWithGoogle: mutate,
  };
};
